module.exports = "img/flags/SR.3929da9.png";